import React from "react";
import { redirect } from "react-router-dom";
import { AuthenticationStore } from "../../stores/authentication/authentication-store";

export async function loader(authenticationStore: AuthenticationStore) {
  await authenticationStore.logout();
  return redirect("/anmelden");
}

export default function Logout(): JSX.Element {
  return <></>;
}
